import Emitter from "./Emitter";

export default class ResetGame extends Emitter {
    constructor(gb) {
        super(gb);
    }

    SLINGO_handler() {
        this.emitGame({ event: "reset" });
    }

    IGT_handler() {
        this.emitGame(JSON.stringify({ message: "cust2rgsReloadGame" }));
    }

    BGS_handler() {
        this.emitGame({ event: "resetGame" });
    }

    RGU_handler() {
        this.emitGame({ event: "resetGame" });
    }

    RAW_handler() {
        this.emitGame({ event: "resetGame" });
    }

    HB_handler() {
        this.emitGame({ event: "resetGame" });
    }

    _default() {
        this.emitGame({ wpgaction: "resetGame" });
    }
}
